export default {
	articles: "Artikel",
	orders: "Bestellarchiv",
	cart: "Warenkorb",
	account: "Konto",
	settings: "Einstellungen",
	manageUsers: "Benutzer verwalten",
	logout: "Abmelden",
	hide: "Verbergen",
	privateAccount: "Privatkonto (Kundennummer: {customerId})",
	companyAccount: "{companyName} (Kundennummer: {customerId})",
	footer: {
		materials: "Werkstoffe",
		materialsTooltip: "Liste der verfügbaren Werkstoffe",
		privacy: "Datenschutz",
		privacyTooltip: "Bestimmungen zum Datenschutz",
		terms: "AGB",
		termsTooltip: "Allgemeine Geschäftsbedingungen von Blexon",
		imprint: "Impressum",
		imprintTooltip: "Impressum",
		languageTooltip: "Sprache in den Kontoeinstellungen anpassen",
	},
};
